<app-progressbar *ngIf="!projectAlarms"></app-progressbar>

<div *ngIf="projectAlarms && !noProjectAlarm">

    <div *ngIf="!readOnly">


        <mat-divider></mat-divider>

        <div class="section">
            <div class="section-title">{{'BUILD_EXPRESSION' | translate}}</div>
            <button class="btn btn-light section-top-button" (click)="resetExpressionElementForm()">Reinit</button>
            <div class="d-flex">
                <div [formGroup]="expressionElementsForm"
                     *ngIf="displayForm"
                     class="alarms-container">
                    <div *ngFor="let element of expressionElementsForm.controls; let i = index;"
                         class="expression-element-container">
                <span *ngIf="element.elementType === 'operator'"
                      class="operator-link">
                </span>
                        <div class="chip-container">
                            <app-combination-alarm-expression-element
                                    [element]="element.value"
                                    [type]="element.elementType"
                                    [valueExternalChanges]="element.valueExternalChanges"
                                    [elementsList]="element.elementType === 'alarm' ? availableAlarms : operators"
                                    (focusElement)="unfocusOtherElements(i, element.elementType);
                                        element.isFocused = true"
                                    (updateElement)="addElement($event, element);
                                        element.isFocused = false;"
                                    (deleteElement)="deleteElement(i)"
                                    (focusOnNextElement)="focusNewInputElement.next(true);">
                            </app-combination-alarm-expression-element>
                            <mat-error *ngIf="element.hasError('incorrect value')
                                            && checkElementHasNoCombinationError(element)">{{'INCORRECT_VALUE' | translate}}
                            </mat-error>
                            <mat-error *ngIf="element.hasError('required')
                                            && checkElementHasNoCombinationError(element)">{{'REQUIRED' | translate}}
                            </mat-error>
                            <mat-error class="wrong-combination-first"
                                       *ngIf="element.hasError('invalid combination: first element')
                                            && !element.hasError('invalid combination: second element')">
                                <span>{{'INVALID_COMBINATION' | translate}}</span>
                            </mat-error>
                            <mat-error class="wrong-combination-second"
                                       *ngIf="element.hasError('invalid combination: second element')
                                            && !element.hasError('invalid combination: first element')">
                            </mat-error>
                            <mat-error class="wrong-combination-middle"
                                       *ngIf="element.hasError('invalid combination: first element')
                                            && element.hasError('invalid combination: second element')">
                            </mat-error>
                        </div>
                        <span *ngIf="element.elementType === 'operator'"
                              class="operator-link">
                </span>
                    </div>
                    <div *ngIf="displayNewInputComponent">
                        <app-combination-alarm-expression-element
                                newElementInput="true"
                                [type]="enabledType"
                                [elementsList]="enabledType === 'alarm' ? availableAlarms : operators"
                                [hasError]="hasBeenSubmitted && 0 === expressionElementsForm.controls.length"
                                [viewIsInited]="viewIsInited"
                                [getFocused]="focusNewInputElement"
                                (focusElement)="unfocusOtherElements();"
                                (updateElement)="addElement($event)">
                        </app-combination-alarm-expression-element>
                        <mat-error class="noBorder"
                                   *ngIf="hasBeenSubmitted && 0 === expressionElementsForm.controls.length">
                            {{'REQUIRED' | translate}}
                        </mat-error>
                    </div>
                </div>
            </div>
            <div class="sub-section">
                <div [ngClass]="{disabled: enabledType !== 'alarm'}">
                    <div class="sub-section-title">{{'CHOOSE_ALARM' | translate}}</div>
                    <button class="btn btn-light alarm"
                            *ngFor="let alarm of projectAlarms"
                            (click)="addElementFromComponentExternalSource(alarm); unfocusOtherElements();"
                            [disabled]="enabledType !== 'alarm' || !availableAlarms.includes(alarm)">
                        {{alarm.name}}
                    </button>
                </div>
                <div class="operator-sub-section" [ngClass]="{disabled: enabledType !== 'operator'}">
                    <div class="sub-section-title">{{'CHOOSE_OPERATOR' | translate}}</div>
                    <button class="btn btn-light operator"
                            *ngFor="let operator of operators"
                            (click)="addElementFromComponentExternalSource(operator); unfocusOtherElements();"
                            [disabled]="enabledType !== 'operator'">
                        {{operator.name}}
                    </button>
                </div>
            </div>
        </div>

        <mat-divider></mat-divider>

        <div class="section">
            <div class="section-title">{{'ADD_MESSAGE' | translate}}</div>
            <input matInput class="basic-input"
                   [placeholder]="'MESSAGE' | translate"
                   [ngClass]="{hasError: form.get('message').touched && form.get('message').invalid}"
                   [formControl]="form.controls.message"
                   [disabled]="readOnly">
            <mat-error class="noBorder"
                       *ngIf="form.get('message').touched
                              && form.get('message').hasError('required')">{{'REQUIRED' | translate}}</mat-error>
            <mat-error class="noBorder"
                       *ngIf="form.get('message').touched
                              && form.get('message').hasError('minlength')">{{'MIN_5_CHARACTERS' | translate}}</mat-error>
        </div>

    </div>


    <div *ngIf="readOnly">

        <div class="section">
            <div class="sub-section">
                <div class="sub-section-title">{{'EXPRESSION' | translate}}:</div>
                <div *ngIf="!invalidFields.includes('expression')" class="alarms-container">
                    <div *ngFor="let element of expressionElementsForm.controls;"
                         class="expression-element-container">
                <span *ngIf="element.elementType === 'operator'"
                      class="operator-link">
                </span>
                        <div class="chip-container">
                            <app-combination-alarm-expression-element
                                    [readOnly]="true"
                                    [element]="element.value"
                                    [type]="element.elementType">
                            </app-combination-alarm-expression-element>
                        </div>
                        <span *ngIf="element.elementType === 'operator'"
                              class="operator-link">
                </span>
                    </div>
                </div>
                <app-invalid-value-error-message
                        *ngIf="invalidFields.includes('expression')"
                        message="INVALID_VALUE">
                </app-invalid-value-error-message>
            </div>
            <div class="sub-section" [ngStyle]="{ marginTop: invalidFields.includes('expression') ? '30px' : '0' }">
                <div class="sub-section-title">{{'MESSAGE' | translate}}:</div>
                <div *ngIf="!invalidFields.includes('message')">{{form.controls.message.value}}</div>
                <app-invalid-value-error-message
                        *ngIf="invalidFields.includes('message')"
                        message="INVALID_VALUE">
                </app-invalid-value-error-message>
            </div>
        </div>

    </div>

</div>

<div *ngIf="noProjectAlarm" class="section">
    <app-invalid-value-error-message message="NO_ALARM">
    </app-invalid-value-error-message>
</div>

